module.exports = __webpack_public_path__ + "img/_54A2254.13470ca8.jpg";